'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'arrow-up';
var width = 448;
var height = 512;
var aliases = [8593];
var unicode = 'f062';
var svgPathData = 'M246.9 17.4l-22.6-22.6-22.6 22.6-160 160-22.6 22.6 45.3 45.3c1.3-1.3 44-44 128-128l0 402.7 64 0 0-402.7c84 84 126.7 126.7 128 128l45.3-45.3-22.6-22.6-160-160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;